<template>
    <div class="parm-container white1 fix">
        <li class="title">
            <p>参数设置</p>
            <div class="horizon gray2"></div>
        </li>
        <li class="filename">
            <p class="first">文件名称：</p>
            <input class="white2 bds bd1 br4" type="text" readonly="readonly">
            <div class="horizon gray2"></div>
        </li>
        <li class="picsize">
            <p class="first">原图片尺寸：</p>
            <div class="twin">
                <p class="fl"></p>
                <p class="fl last"></p>
            </div>
            <div class="cb"></div>
            <div class="horizon gray2 non"></div>
        </li>
        <!-- 几个菜单 -->
        <li class="menu-block menu-text non">
            <p class="first">字体大小：</p>
            <input class="white2 bds bd1 brl fl" type="text" readonly="readonly" value="50pt">
            <div class="fl brr">
                <img src="img/gen/ico_tiaozheng.png" @click="TextSizeUp()" class="cp">
                <div class="horizon gray2"></div>
                <img src="img/gen/ico_xiala.png" @click="TextSizeDown()" class="cp">
            </div>
            <div class="cb plus"></div>
            <div class="color cb ret">
                <p>字体颜色：</p>
                <ul></ul>
            </div>
        </li>
        <li class="menu-block menu-edit non">
            <p class="first">编辑文字：</p>
            <textarea maxlength="50" @keyup="descInput()"></textarea>
        </li>
        <li class="menu-block menu-shape non">
            <p class="first">区域尺寸：</p>
            <div class="twin">
                <p class="fl">高：</p>
                <p class="fl last">宽：</p>
            </div>
            <div class="color cb ret">
                <p>形状颜色：</p>
                <ul></ul>
            </div>
        </li>
        <li class="menu-block menu-crop non">
            <p class="first">裁剪尺寸：</p>
            <div class="twin">
                <p class="fl">高：</p>
                <p class="fl last">宽：</p>
            </div>
            <div class="non">
                <p class="cb">裁剪比例：</p>
                <input class="white2 bds bd1 brl fl" type="text" readonly="readonly" value="自由比例">
                <div class="fl brr last">
                    <img src="img/gen/ico_xiala.png" alt>
                </div>
            </div>
        </li>
        <li class="menu-block menu-rotate non">
            <p class="first">旋转角度：</p>
            <div class="cp" @click="RotCW()">
                <img src="img/gen/icon_ssz.png">
                顺时针旋转 90°
            </div>
            <div class="cp" @click="RotCCW()">
                <img src="img/gen/icon_nsz.png">
                逆时针旋转 90°
            </div>
            <p>自由旋转：</p>
            <div>
                -180°
                <input type="range" min="-180" max="180" class="cp" value="0">180°
            </div>
        </li>
        <li class="menu-block non menu-flip">
            <p class="first">镜像方向：</p>
            <input class="white2 bds bd1 brl fl" type="text" readonly="readonly" value="横向">
            <div class="fl brr last">
                <img src="img/gen/ico_xiala.png" alt>
            </div>
            <div class="tes cb">
                <div class="cp ct grn1">左右翻转</div>
                <div class="cp ct grn1">上下翻转</div>
            </div>
        </li>
        <!-- 几个菜单 -->
        <li class="save abs">
            <div class="horizon gray2"></div>
            <p class="first">保存路径：</p>
            <input class="white2 bds bd1 brl fl" type="text" readonly="readonly" :value="outPath">
            <div class="fl brr last cp ct" @click="ChanPath()">更改</div>
            <div class="cb"></div>
            <div class="btn-down-load cp ct" @click="SavePng()">保存文件</div>
        </li>
    </div>
</template>
<script>
import File from "../../mixin/File.js";
export default {
    name: "Parm",
    mixins: [File],
    mounted() {
        var _this = this;
        _this.outPath = _this.homePath;
        _this.areaTxt = window.$('.menu-edit').find('textarea');
        _this.rotBar = window.$('.menu-rotate').find('input');
        _this.rotBar.on('input', function () {
            var a = _this.rotBar.val();
            var ang = parseInt(a, 10);
            var imageEditor = window.imageEditor;
            if (window.aoTp == 'group') {
                imageEditor.discardSelection();
            }
            imageEditor.setAngle(ang);
        });
        window.txtPick.txSz = window.$('.menu-text').find('input').first();
    },
    data() {
        return {
            areaTxt: null,
            rotRange: 90,
            rotBar: null,
            outPath: '',
            homePath: window.os.homedir() + "\\Desktop"
        };
    },
    props: ['savImg'],
    methods: {
        descInput() {
            //同步画布中的文字内容
            var str = this.areaTxt.val();
            var txt = window.txtPick;
            var id = window.aoId;
            var imageEditor = window.imageEditor;
            imageEditor.changeText(id, str);
            txt.ChanTS(id, 'con', str);
            //撤销重做后只剩下一个，其实都在，只是 undostack 里一堆空改变
        },
        TextSizeUp() {
            window.txtPick.SetSize(true);
        },
        TextSizeDown() {
            window.txtPick.SetSize(false);
        },
        ChanPath() {
            let _this = this;
            _this.selectPath(function (path) {
                _this.outPath = path;
            });
        },
        SavePng() {
            var _this = this;
            var imageEditor = window.imageEditor;
            var imageName = imageEditor.getImageName();
            var headName = imageName.split(".").shift();
            //先判断保存路径是否存在，可能已经被删
            var pathok = window.fs.existsSync(_this.outPath);
            if (!pathok) {
                _this.outPath = _this.homePath;
            }
            //如果当前路径下有这个文件，提示会覆盖，先不管了 ★ ★ ★ ★ ★
            var dataURL = imageEditor.toDataURL({
                format: 'gif', // png 的话质量不起作用 jpeg
                quality: 0.1
            });
            var base64Data = dataURL.replace(/^data:image\/\w+;base64,/, "");
            var dataBuffer = new Buffer(base64Data, 'base64');
            var finFile = _this.outPath + "\\" + headName + ".png";
            window.fs.writeFile(finFile, dataBuffer, function (err) {
                if (err) {
                    console.log(err); //如果路径不存在的话
                    window.toastr.error('保存失败...');
                } else {
                    _this.savImg(finFile); //通知父组件，改变底下缩略图
                    window.toastr.success('图片保存成功!');
                }
            });
        },
        RotCW() {
            var ang = this.rotBar.val();
            var a = parseInt(ang, 10);
            if (a > 180 - this.rotRange) {
                a = -180 + this.rotRange;
            } else {
                a += this.rotRange;
            }
            this.rotBar.val(a);
            var imageEditor = window.imageEditor;
            if (window.aoTp == 'group') {
                imageEditor.discardSelection();
            }
            imageEditor.setAngle(a);
        },
        RotCCW() {
            var ang = this.rotBar.val();
            var a = parseInt(ang, 10);
            if (a < -180 + this.rotRange) {
                a = 180 - this.rotRange;
            } else {
                a -= this.rotRange;
            }
            this.rotBar.val(a);
            var imageEditor = window.imageEditor;
            if (window.aoTp == 'group') {
                imageEditor.discardSelection();
            }
            imageEditor.setAngle(a);
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.menu-crop .tes {
    left: -100px;
    top: 86px;
}
.tes p {
    padding-left: 10px;
    padding-right: 10px;
}
textarea {
    width: 186px;
    height: 100px;
    outline: none;
    resize: none;
}
/* 文字菜单的输入框 */
p {
    font-size: 12px;
    color: #464851;
}
div {
    font-size: 12px;
    color: #7a8c9c;
}
.title p {
    padding-top: 8px;
    padding-bottom: 10px;
}
.menu-block p {
    padding-top: 11px;
    padding-bottom: 9px;
}
.menu-block .last img {
    padding-top: 8px;
}
p.first {
    padding-top: 18px;
    padding-bottom: 9px;
}
.filename input {
    width: 185px;
    margin-bottom: 14px;
}
.parm-container {
    width: 205px;
    right: 1px;
    top: 118px;
    bottom: 1px;
    border-left: 1px solid #e2e5ec;
    border-top: 1px solid #e2e5ec;
}
.parm-container li {
    margin-left: 9px;
}
.horizon {
    width: 196px;
    height: 1px;
}
.twin {
    margin-top: 5px;
}
.twin p {
    width: 90px;
    color: #7a8c9c;
}
.twin .last {
    margin-left: 5px;
}
.picsize .cb {
    height: 17px;
}
.menu-block .twin p {
    padding-top: 0px;
    padding-bottom: 6px;
}
.menu-block .twin {
    padding-bottom: 5px;
}
.menu-text .plus {
    height: 2px;
}
.menu-rotate div {
    line-height: 22px;
}
.menu-rotate input {
    padding-left: 0px;
    width: 125px;
    vertical-align: middle;
}
.menu-rotate img {
    vertical-align: middle;
}
/* a */
input {
    height: 25px;
    padding-left: 6px;
    font-size: 12px;
    color: #7a8c9c;
}
input.brl {
    width: 50px;
}
.brl {
    border-radius: 4px 0px 0px 4px;
}
.brr {
    width: 16px;
    height: 23px;
    border-radius: 0px 4px 4px 0px;
    border-right: 1px solid #e2e5ec;
    border-top: 1px solid #e2e5ec;
    border-bottom: 1px solid #e2e5ec;
}
.brr .horizon {
    width: 16px;
    height: 1px;
}
.brr img {
    padding-top: 1px;
    padding-bottom: 2px;
    padding-left: 5px;
}
.menu-crop input {
    width: 62px;
}
/* 底下保存 */
.save {
    height: 149px;
    bottom: 0px;
}
.save .last {
    width: 42px;
    line-height: 22px;
}
.save input {
    width: 142px;
}
.btn-down-load {
    margin-left: 12px;
    margin-top: 29px;
    width: 164px;
    height: 38px;
    line-height: 38px;
    font-size: 14px;
    color: white;
    border-radius: 19px;
    background: linear-gradient(-90deg, #10c375, #12c3a8);
}
.btn-down-load:hover {
    background: #11c38a;
}
.btn-down-load:active {
    background: #11c3a3;
}
/* 滑条 */
input[type="range"] {
    width: 125px;
    -webkit-appearance: none;
}
input[type="range"]:focus {
    outline: none;
}
/* 滑块 */
input[type="range"]::-webkit-slider-thumb {
    height: 12px;
    width: 12px;
    margin-top: -5px;
    background-color: white;
    border-radius: 50%;
    border: 1px solid #e2e5ec;
    -webkit-appearance: none;
}
/* 轨道 */
input[type="range"]::-webkit-slider-runnable-track {
    margin-top: -2px;
    height: 2px;
    background-color: #ededed;
}
</style>